import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '@features/authentication/store/authStore';

export function PublicRoute() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);

  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
